function generatePayloadFromObject(obj: Record<string, string>): string {
    let payload = ''
    let idx = 0
    for (const [key, value] of Object.entries(obj)) {
        payload += `${idx === 0 ? '' : '&'}${key}=${value}`
        idx++
    }

    return payload
}

export default generatePayloadFromObject
